import { render, staticRenderFns } from "./CreditRating.vue?vue&type=template&id=545b3741&"
import script from "./CreditRating.vue?vue&type=script&lang=js&"
export * from "./CreditRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports